export const MARK_DEV_CHANGE = "devForm/MARK_DEV_CHANGE";
export const RESET_CHANGE_FLAG = "devForm/RESET_CHANGE_FLAG";

export const markDevFormChanged = () => ({
   type: MARK_DEV_CHANGE,
});

export const resetChangeFlag = () => ({
   type: RESET_CHANGE_FLAG,
});
